import { AuthClient } from "@/utils/client";

export const updateSubscription = (data: any) => {
  return AuthClient().patch(`/common/update-subscription`, data);
};
